/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown> }} Orders_Pxk_Item_Lot_IndexInputs */

const vi_orders_pxk_item_lot_index = /** @type {(inputs: Orders_Pxk_Item_Lot_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lô ${i?.index}/${i?.total}`)
};

/**

* @param {Orders_Pxk_Item_Lot_IndexInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_item_lot_index = /** @type {((inputs: Orders_Pxk_Item_Lot_IndexInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Item_Lot_IndexInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_item_lot_index(inputs)
});